import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useIntercom } from 'react-use-intercom';
import tw from 'twin.macro';
import { useAtomValue, useSetAtom } from 'jotai';

import { ButtonV2 } from '@restworld/ui-ds';
import { HeadphoneIcon } from '@restworld/utils-common';

import { activeRestaurantAtom } from './google-address-input-result';
import { activeRestaurantOnboardingStateAtom } from '.';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IEstablishmentNotHORECAProps {}

const Container = tw.div`w-full h-full inline-flex flex-col justify-center items-center gap-10`;
const Section = tw.div`self-stretch flex flex-col justify-start items-start gap-4`;
const Title = tw.h5`self-stretch text-center justify-start text-neutral-700 text-xl font-semibold`;
const Subtitle = tw.h5`self-stretch text-center justify-start text-neutral-200 text-base font-medium`;
const HeaderTitle = tw.h5`text-center justify-start text-neutral-700 text-sm font-medium`;
const ButtonTitle = tw.h5`text-purple-700 text-base font-semibold`;

const EstablishmentNotHORECA: React.FunctionComponent<IEstablishmentNotHORECAProps> = () => {
  const { t } = useTranslation('restaurant-onboarding');
  const { showMessages } = useIntercom();
  const setActiveUI = useSetAtom(activeRestaurantOnboardingStateAtom);
  const activeRestaurant = useAtomValue(activeRestaurantAtom);

  const redirectToFirstStep = React.useCallback(() => setActiveUI('select_restaurant_from_google'), [setActiveUI]);
  return (
    <Container>
      <Section>
        <Title>{t('establishment_not_horeca.title')}</Title>
        <Subtitle tw="flex flex-col gap-8">
          <Subtitle>{activeRestaurant}</Subtitle>
          <Subtitle>{t('establishment_not_horeca.subtitle')}</Subtitle>
        </Subtitle>
      </Section>
      <Section>
        <HeaderTitle>{t('establishment_not_horeca.actions.primary.header_title')}</HeaderTitle>
        <ButtonV2
          EndIcon={MagnifyingGlassIcon}
          variant="secondary-restworld"
          tw="w-full"
          size="md"
          onClick={redirectToFirstStep}
        >
          <ButtonTitle>{t('establishment_not_horeca.actions.primary.button_title')}</ButtonTitle>
        </ButtonV2>
      </Section>
      <Section>
        <HeaderTitle>{t('establishment_not_horeca.actions.secondary.header_title')}</HeaderTitle>
        <ButtonV2
          EndIcon={HeadphoneIcon}
          variant="secondary-restworld"
          tw="w-full"
          size="md"
          onClick={(e) => {
            e.preventDefault();
            showMessages();
          }}
        >
          <ButtonTitle>{t('establishment_not_horeca.actions.secondary.button_title')}</ButtonTitle>
        </ButtonV2>
      </Section>
    </Container>
  );
};

export default EstablishmentNotHORECA;
